
/* injects from baggage-loader */

'use strict'

import { genSecureHex } from '_appRoot/core/services/secure-random';

import { TrashIcons, initFeedbackTexts, feedbackTexts, helpTpl } from './stage-two.const';

import { shuffle, random, findIndex } from 'lodash';

export default class StageTwoController{
    constructor($log, $rootScope, $state, $timeout, Dialog, Session) {
        'ngInject'; 
        
        this.name = "Stage 2";
        this.$log = $log;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.Session = Session;

        this.state = {
            totalItems: 0,
            trashInFocus: false
        };

        
        this.items = [];

        this.model = {
            paper: [],
            glass: [],
            metal: []
        };        
    }

    $onInit(){
        this.createItems();        
        let updates = this.Session.get();
        let stageIndex = findIndex(updates.stages, { name: this.name });

        updates.stages[stageIndex].timesEntered++;

        this.Dialog.showFeedbackIbama('label-onca', initFeedbackTexts, () => {
            if (updates.stages[stageIndex].firstRun) {
                console.log("entrou!!!");
                updates.stages[stageIndex].firstRun = false;
                this.Session.save(updates);
                this.openHelp();
            }else{
                this.Session.save(updates);
            }
        });
    }

    $onDestroy(){
        this.$rootScope.$emit('modal.closing');
    }
    
    openHelp(){
        this.Dialog.showBigAlert('label-help', helpTpl);
    }

    onDrop($event, data, items, type){
        if(type === data.type){
            let indexOf = findIndex(items, { id: data.id });            
            this.model[data.type].push(data);            
            this.items.splice(indexOf, 1);

            if(this.isValid()){
                this.$timeout(() => {
                    this.Dialog.showFeedback('label-very-good', feedbackTexts, 'btn-continue', this.onShowFeedbackSuccess.bind(this));
                }, 1200);
            }
        }
    }
    
    dropValidate(type, data){
        return type === data.type;
    }
    

    // Feedback callbacks
    onShowFeedbackSuccess(){
        this.$timeout(() => {
            this.state.trashInFocus = true;
            this.Dialog.showGraphOnca(this.model, this.onShowGraphOnca.bind(this))
        }, 1200);
    }

    onShowGraphOnca(){
        this.state.trashInFocus = false
    }    

    // Generators

    createItems(){
        
        let quantities = [random(1, 6, false),random(1, 6, false),random(1, 6, false)];
        quantities = shuffle(quantities);
        
        let glass = this.createItem('glass',quantities[0]);
        let paper = this.createItem('paper',quantities[1]);
        let metal = this.createItem('metal',quantities[2]);

        let items = [];
        
        items = items.concat(glass);
        items = items.concat(metal);
        items = items.concat(paper);

        this.items = shuffle(items);
        this.state.totalItems = this.items.length;
    }


    createItem(type, total){
        let items = [];
        
        if(!total){
            total = random(3, 5, false);
        }
            
        for(let i = 0; i < total; i++){
            let item = {
                id: genSecureHex(),
                type: type,
                images: {
                    default: TrashIcons[type].default,
                    submerged: TrashIcons[type].submerged
                }
            }

            items.push(Object.assign(this.createItemPosition(), item));
        }

        return items;
    }

    createItemPosition(){
        return {
            position:{
                top: `${random(200, 500)}px`,
                left: `${random(25, 100)}px`
            }
        }
    }

    isValid(){
        let totalModelItems = 0;

        angular.forEach(this.model, object => {
            totalModelItems += object.length;
        });

        return this.state.totalItems === totalModelItems;
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-two/stage-two.controller.js